import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';


class Nav extends Component {

  state = {};

  render() {
    let { location } = this.props;
    return (
      <ul className="nav">  
        {/* <li className={this.isPathActive('/register') ? 'active' : null}>
          <Link to="/register">
            <i className="pe-7s-add-user"></i>
            <p>Register</p>
          </Link>
        </li>    */}
        {/* <li className={this.isPathActive('/players') ? 'active' : null}>
          <Link to="/players">
            <i className="pe-7s-user"></i>
            <p>players</p>
          </Link>
        </li>              */}
        <li className={this.isPathActive('/teams') ? 'active' : null}>
          <Link to="/teams">
            <i className="pe-7s-users"></i>
            <p>Teams</p>
          </Link>
        </li>
        <li className={this.isPathActive('/schedule') ? 'active' : null}>
          <Link to="/schedule">
            <i className="pe-7s-date"></i>
            <p>Schedule</p>
          </Link>
        </li>
        <li className={this.isPathActive('/teamtanding') ? 'active' : null}>
          <Link to="/teamtanding">
            <i className="pe-7s-graph1"></i>
            <p>Team Standing</p>
          </Link>
        </li>
        <li className={this.isPathActive('/top-performers') ? 'active' : null}>
          <Link to="/top-performers">
            <i className="pe-7s-medal"></i>
            <p>Top Performers</p>
          </Link>
        </li>
        <li className={this.isPathActive('/gameresults') ? 'active' : null}>
          <Link to="/gameresults">
            <i className="pe-7s-cup"></i>
            <p>Game Results</p>
          </Link>
        </li>
        <li className={this.isPathActive('/upcoming') ? 'active' : null}>
          <Link to="/upcoming">
            <i className="pe-7s-wristwatch"></i>
            <p>Upcoming Games</p>
          </Link>
        </li>
        <li className={this.isPathActive('/scores') ? 'active' : null}>
          <Link to="/scores">
            <i className="pe-7s-look"></i>
            <p>Live Scores</p>
          </Link>
        </li>
        <li className={this.isPathActive('/rules') ? 'active' : null}>
          <Link to="/rules">
            <i className="pe-7s-notebook"></i>
            <p>Rules</p>
          </Link>
        </li>
      </ul>
    );
  }

  isPathActive(path) {
    return this.props.location.pathname.startsWith(path);
  }
}

export default withRouter(Nav);


// WEBPACK FOOTER //
// ./src/components/SideBar/Nav.js